import styled, { keyframes } from "styled-components";
import { Logo, Loading } from "../../../services/visualLibraryService";

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const LogoStyled = styled(Logo)`
  animation: ${fadeIn} 0.5s ease-out;
`;

export const SplashStyled = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${props => props.theme.background};
  z-index: ${props => props.theme.zIndex.base};
  display: flex;
`;

export const ContainerStyled = styled.div`
  margin: auto;
  text-align: center;
`;

export const LoadingStyled = styled(Loading)`
  margin: ${props => props.theme.spacing.large} auto 0;
`;
